import * as React from 'react';

export const CalandarSelectIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="CalendarMD">
      <path
        id="Vector"
        d="M11.6 2.1002V0.700195H10.4V2.1002H5.60002V0.700195H4.40002V2.1002H0.900024V8.9602C0.900024 14.7082 1.56302 15.3002 8.00002 15.3002C14.437 15.3002 15.1 14.7082 15.1 8.9602V2.1002H11.6ZM13.9 8.9602C13.9 13.9072 13.9 14.1002 8.00002 14.1002C2.10002 14.1002 2.10002 13.9072 2.10002 8.9602V3.3002H4.40002V4.7002H5.60002V3.3002H10.4V4.7002H11.6V3.3002H13.9V8.9602ZM6.12302 6.8752L8.60002 5.8402V11.2002H7.40002V7.6412L6.58402 7.9812L6.12302 6.8747V6.8752Z"
        fill="black"
      />
    </g>
    <defs>
      <clipPath id="clip0_1641_10139">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
